<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/egresos`;
const token = utilsService.getToken();

const egresoService = {
  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getAllFiltered(formRaw) {
    try {
      const form = { ...formRaw };
      form.estadoPago = form.estadoPago || 0;
      form.numeroFolio = form.numeroFolio || 0;
      form.planta = form.planta || 0;
      form.empresa = form.empresa || 0;
      form.egreso = form.egreso || 0;
      const response = await axios.post(`${apiUrl}/filtered`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      response.data.choferID = response.data.choferID == 0 ? null : response.data.choferID;
      response.data.estadoID = response.data.estadoID == 0 ? null : response.data.estadoID;
      response.data.estadoPagoID = response.data.estadoPagoID == 0 ? null : response.data.estadoPagoID;
      response.data.empresaID = response.data.empresaID == 0 ? null : response.data.empresaID;
      response.data.materialID = response.data.materialID == 0 ? null : response.data.materialID;
      response.data.noConformidadID = response.data.noConformidadID == 0 ? null : response.data.noConformidadID;
      response.data.monedaID = response.data.monedaID == 0 ? null : response.data.monedaID;
      response.data.paisID = response.data.paisID == 0 ? null : response.data.paisID;
      response.data.plantaOrigenID = response.data.plantaOrigenID == 0 ? null : response.data.plantaOrigenID;
      response.data.plantaDestinoID = response.data.plantaDestinoID == 0 ? null : response.data.plantaDestinoID;
      response.data.empresaDestinoID = response.data.empresaDestinoID == 0 ? null : response.data.empresaDestinoID;
      response.data.pasilloDestinoID = response.data.pasilloDestinoID == 0 ? null : response.data.pasilloDestinoID;
      response.data.pasilloOrigenID = response.data.pasilloOrigenID == 0 ? null : response.data.pasilloOrigenID;
      response.data.montoGuiaTraslado = response.data.montoGuiaTraslado == 0 ? null : response.data.montoGuiaTraslado;
      response.data.pesoTotal = response.data.pesoTotal.toString().replace(/\./g, ',');
      response.data.peso = response.data.peso.toString().replace(/\./g, ',');
      response.data.pesoInex = response.data.pesoInex.toString().replace(/\./g, ',');
      response.data.precio = response.data.precio.toString().replace(/\./g, ',');
      response.data.numeroActa = response.data.numeroActa == 0 ? null : response.data.numeroActa;
      response.data.numeroFolio = response.data.numeroFolio == 0 ? null : response.data.numeroFolio;
      response.data.ingresoID = response.data.ingresoID == 0 ? null : response.data.ingresoID;

      return response.data;
    } catch (error) {
      if (error.status == "404")
        window.location.href = '/error';
      console.log(error.message);
    }
  },

  async getAdjuntos(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}/adjuntos`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const promises = response.data.map(async (item) => {
        try {
          const urlCheck = await utilsService.checkUrl(item.url);
          if (!urlCheck) item.url = "/img/others/no-photo.svg";
          return item;
        } catch (error) {
          console.error('Error checking URL:', error);
          return null;
        }
      });

      const adjuntos = await Promise.all(promises);
      return adjuntos;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const form = { ...formRaw };
      form.NumeroActa = form.NumeroActa || 0;
      form.NumeroFolio = form.NumeroFolio || 0;
      form.PorcentajeProducto = form.PorcentajeProducto || 0;
      form.Precio = form.Precio || 0;
      form.PesoTotal = form.PesoTotal || 0;
      form.PesoInex = form.PesoInex || 0;
      form.Descuento = form.Descuento || 0;
      form.ChoferID = form.ChoferID || 0;
      form.EmpresaID = form.EmpresaID || 0;
      form.EmpresaDestinoID = form.EmpresaDestinoID || 0;
      form.PlantaDestinoID = form.PlantaDestinoID || 0;
      form.PlantaOrigenID = form.PlantaOrigenID || 0;
      form.EmpresaDestinoID = form.EmpresaDestinoID || 0;
      form.NoConformidadID = form.NoConformidadID || 0;

      const response = await axios.post(`${apiUrl}/create`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el egreso.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async update(formRaw, id) {
    try {
      const form = { ...formRaw };
      form.numeroActa = form.numeroActa || 0;
      form.numeroFolio = form.numeroFolio || 0;
      form.porcentajeProducto = form.porcentajeProducto || 0;
      form.precio = form.precio || 0;
      form.pesoTotal = form.pesoTotal || 0;
      form.pesoInex = form.pesoInex || 0;
      form.descuento = form.descuento || 0;
      form.choferID = form.choferID || 0;
      form.empresaID = form.empresaID || 0;
      form.noConformidadID = form.noConformidadID || 0;
      form.estadoPagoID = form.estadoPagoID || 0;
      form.estadoID = form.estadoID || 0;
      form.ingresoID = form.ingresoID || 0;
      form.precio = form.precio.replace(/\./g, '') || 0;
      form.peso = form.peso.toString().replace(/\./g, '') || 0;
      form.peso = form.peso.toString().replace(/\,/g, '.') || 0;

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.status;
    } catch (error) {
      let message = "Error en la solicitud.";
      if (error.response && error.response.data) {
        message = error.response.data.message;
      } else {

        message = error.message;
      }
      throw new Error(message);
    }
  },

  async getEstadosOptions() {
    try {
      const response = await axios.get(`${apiUrl}/estados/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async addFactura(egresos, factura) {
    try {
      const formData = new FormData();
      formData.append("numero", factura.numero);
      formData.append("fecha", factura.fecha);
      formData.append("file", factura.file);
      egresos.forEach(id => formData.append("egresos", id));

      const response = await axios.post(`${apiUrl}/factura`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async delFactura(egresos) {
    try {
      const response = await axios.delete(`${apiUrl}/factura/delete`, {
        data: egresos,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async addAdjunto(adjunto) {
    try {
      const formData = new FormData();
      formData.append("file", adjunto.file);
      formData.append("tipoID", adjunto.tipoID);
      formData.append("egresoID", adjunto.egresoID);
      console.log(formData);
      const response = await axios.post(`${apiUrl}/adjunto`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async delAdjunto(id) {
    try {
      const response = await axios.delete(`${apiUrl}/adjunto/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getegresosPagados(init, end, ep) {
    try {
      const response = await axios.get(`${apiUrl}/reporte-egresos-pagados`, {
        params: {
          fechaInicio: init,
          fechaFin: end,
          grupoEstado: 4
        },
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        responseType: 'blob', 
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().slice(0, 10);
      link.setAttribute('download', `reporte_egresos-pagados_${fechaActual}.xlsx`);

      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
    } catch (error) {
      throw Error(error)
    }
  },
};

export default egresoService;
</script>
